import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ImagePreviewDialogProps {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  generatedImage: string | null;
  onSaveDrill: () => void;
}

const ImagePreviewDialog = ({
  showDialog,
  setShowDialog,
  generatedImage,
  onSaveDrill,
}: ImagePreviewDialogProps) => {
  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent className="sm:max-w-[800px]">
        <DialogHeader>
          <DialogTitle>Generated Drill Image</DialogTitle>
          <DialogDescription>
            Review the generated image and save the drill if you're satisfied
          </DialogDescription>
        </DialogHeader>
        {generatedImage && (
          <div className="mt-4">
            <div className="w-full h-[400px] relative rounded-lg overflow-hidden bg-gray-50">
              <img
                src={generatedImage}
                alt="Generated drill diagram"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <Button variant="outline" onClick={() => setShowDialog(false)}>
                Close
              </Button>
              <Button onClick={onSaveDrill}>
                Save Drill
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;